import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/axios.js';

export function useDashboard(filters = {}) {
  return useQuery({
    queryKey: ['metricas', 'dashboard', filters],
    queryFn: () => api.get('/metricas/dashboard', { params: filters }).then((r) => r.data),
  });
}

export function useMetricasVendedor(vendedor_id, filters = {}) {
  return useQuery({
    queryKey: ['metricas', 'vendedor', vendedor_id, filters],
    queryFn: () => api.get(`/metricas/vendedor/${vendedor_id}`, { params: filters }).then((r) => r.data),
    enabled: !!vendedor_id,
  });
}
